import { render } from "./AdminRiderraterangeList.vue?vue&type=template&id=1fbb7e08&ts=true&lang=true"
import script from "./AdminRiderraterangeList.vue?vue&type=script&lang=ts"
export * from "./AdminRiderraterangeList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__